import React, { useEffect, useRef } from 'react';
import { FieldContainer } from './styles';
import { useField } from '../Form';

export default function SelectAlt({ name, label, options, ...rest }) {
  const inputRef = useRef(null);

  const { fieldName, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <FieldContainer>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <select ref={inputRef} id={fieldName} {...rest}>
        {options &&
          options.map(option => (
            <option key={option.id} value={option.value}>
              {option.text}
            </option>
          ))}
      </select>
    </FieldContainer>
  );
}
